
<template>
  <div class="traffic">
    <div class="traffic-change">
      <el-select v-model="application" placeholder="请选择" @change="getData()">
        <el-option
          v-for="item in list"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select v-model="year" placeholder="请选择" @change="getData()">
        <el-option
          v-for="item in yearList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div id="lineChart" ref="lineChart"></div>
  </div>
</template>

<script>
import { listAreaRate } from '@api/cockpit'
import * as echarts from 'echarts'
export default {
  name: 'traffic',
  data() {
    return {
      application: '丽水市',
      year: 2022,
      lineChart: null,
      list: [
        { value: '丽水市', label: '丽水市' },
        { value: '莲都区', label: '莲都区' },
        { value: '遂昌县', label: '遂昌县' },
        { value: '松阳县', label: '松阳县' },
        { value: '龙泉市', label: '龙泉市' },
        { value: '庆元县', label: '庆元县' },
        { value: '青田县', label: '青田县' },
        { value: '缙云县', label: '缙云县' },
        { value: '景宁县', label: '景宁畲族自治县' }
      ],
      yearList: [
        { value: 2022, label: '2022年' },
        { value: 2021, label: '2021年' }
      ],
      option: {
        color: ['#02FFFE', '#35AAFF'],
        grid: {
          containLabel: true,
          bottom: '20',
          left: '10'
        },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        legend: {
          show: true,
          x: 'center',
          y: 'top',
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月'],
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 14
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              opacity: 0.5
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '单位：次',
            axisLabel: {
              color: 'rgba(255, 255, 255, 0.65)',
              fontSize: 10
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                opacity: 0.5,
                width: 0.3
              }
            }
          }
        ],
        series: [
          {
            name: 'PV',
            data: [
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1)
            ],
            type: 'line',
            barWidth: 10,
            backgroundStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#02FFFE' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#02FFFE' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            name: 'UV',
            data: [
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1),
              Math.floor(Math.random() * 100 + 1)
            ],
            type: 'line',
            barWidth: 10,
            backgroundStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#35AAFF ' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: '#35AAFF ' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      }
    }
  },
  mounted() {
    this.initChart()
    this.getData()
  },
  methods: {
    initChart() {
      const that = this
      this.lineChart = echarts.init(this.$refs.lineChart)
      window.addEventListener('resize', function () {
        that.lineChart.resize()
      })
    },
    getOption() {
      const options = {}
      return options
    },
    getData() {
      let par = {
        county: this.application,
        year: this.year
      }
      listAreaRate(par).then((res) => {
        if (res.data.code == '0000') {
          const data = res.data.data
          this.option.series[0].data = data.pvList.map((item) => {
            return item.value
          })
          this.option.series[1].data = data.uvList.map((item) => {
            return item.value
          })
          this.option.xAxis.data = data.uvList.map((item) => {
            return item.month
          })
          this.lineChart.setOption(this.option, true)
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-select {
  width: 1.5rem;
  margin-right: 0.2rem;
  .el-input__inner {
    height: 0.32rem;
    color: rgba(255, 255, 255, 100);
    background-color: rgba(11, 24, 35, 1);
    border: 0.01rem solid rgba(45, 56, 75, 1);
  }
  .el-input--medium .el-input__icon {
    line-height: 0.32rem;
  }
}
.traffic {
  width: 100%;
  height: 4rem;
  #lineChart {
    margin-top: 0.2rem;
    width: 100%;
    height: 3.5rem;
  }
}
</style>
